import script from "./InterestedSkills.vue?vue&type=script&setup=true&lang=js"
export * from "./InterestedSkills.vue?vue&type=script&setup=true&lang=js"

import "./InterestedSkills.vue?vue&type=style&index=0&id=1ef8eb39&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ef8eb39"]])

export default __exports__